import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgSend = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "currentColor",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("mask", {
		id: "mask0_892_20147",
		style: { maskType: "alpha" },
		maskUnits: "userSpaceOnUse",
		x: 0,
		y: 0,
		width: 24,
		height: 24,
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24
		})
	}), /* @__PURE__ */ _jsx("g", {
		mask: "url(#mask0_892_20147)",
		children: /* @__PURE__ */ _jsx("path", { d: "M3.5 19.2499V4.75L20.7114 11.9999L3.5 19.2499ZM4.99997 16.9999L16.85 11.9999L4.99997 6.99995V10.6923L10.423 11.9999L4.99997 13.3076V16.9999Z" })
	})]
});
export default SvgSend;
